import {
	Box,
	Grid,
	Stack,
	Typography,
	CardContent,
	InputAdornment,
	Dialog,
	CircularProgress,
	IconButton
} from "@mui/material";
import React from "react";
import { useState, useEffect } from "react";
import "./login.scss";
import forgotpassword from "../../assets/forgotpassword.svg";
import { StyledTextBox } from "../../components/ui/TextBox";
import { StyledCard } from "../../components/ui/Cards";
import { BlackOutlinedButton, ContainedButton } from "../../components/ui/Buttons";
import {
	GetResetPassword,
	PostResetPassword,
	ResetPasswordTokenVerify,
} from "../../services/auth.services";
import { NavLink } from "react-router-dom";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import AlertSnackbar from "../../components/shared/notifications/AlertSnackBar";
import { LoadingBox } from "../../components/ui/Box";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function ResetPassword() {
	const [email, setEmail] = useState('');
	const [checkEmail, setCheckEmail] = useState(false);
	const [modal, setModal] = useState(false);
	const [snackBarAlert, setSnackBarAlert] = useState(false);
	const [snackBarAlertMessage, setSnackBarAlertMessage] = useState('');
	const [newPasswordUi, setNewPasswordUi] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [password, setPassword] = useState("");
	const [confirmPassword, setPasswordConfirm] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [errorCheckPassword, setErrorCheckPassword] = useState(false);
	const [passwordMessage, setPasswordMessage] = useState("");
	const [passwordConfirmMessage, setPasswordConfirmMessage] = useState("");
	const [errorCheckPasswordConfirm, setErrorCheckPasswordConfirm] = useState(false);
	const [token, setToken] = useState('');
	const [passwordResetSuccess, setPasswordResetSuccess] = useState(false);

	useEffect(() => {
		const currentUrl = window.location.href;
		const urlParams = new URLSearchParams(currentUrl.split("?")[1]);
		// Create an empty object to store parameters
		const params = {};

		// Loop through all parameters and add them to the object
		for (const [key, value] of urlParams.entries()) {
			params[key] = value;
		}
		// Log the parameters object
		if (params.code) {
			setIsLoading(true);
			setToken(params.code);
			try {
				ResetPasswordTokenVerify(params.code).then(({ response, result }) => {
					setIsLoading(false);
					if (!response.ok) {
						setSnackBarAlert(true);
						setSnackBarAlertMessage(result?.message || 'Somthing went wrong.');
						return;
					}
					setNewPasswordUi(true);
				})

			} catch (error) {
				setSnackBarAlert(true);
				setSnackBarAlertMessage('Somthing went wrong.');
				console.error('Error', error);;
			}
		}
	}, []);

	const handleSubmit = (event) => {
		event.preventDefault();
		let error = false;

		if (email === "") {
			setCheckEmail(true);
			error = true;
			setSnackBarAlert(true);
			setSnackBarAlertMessage('The email you entered is incorrect.');
		} else {
			setCheckEmail(false);
		}

		if (!error) {
			try {
				GetResetPassword(email).then(({ response, result }) => {
					if (error || !response.ok) {
						let message = 'Something went wrong';

						if (response.status === 404) {
							message = 'If an account with this email exists, a password reset link has been sent.';
						} else if (response.status === 401) {
							message = 'The email you entered is incorrect.';
						} else if (error) {
							message = result?.message || 'Somthing went wrong try refreshing.';
						}

						setSnackBarAlert(true);
						setSnackBarAlertMessage(message);
						return;
					}
					setModal(true);
				})

			} catch (error) {
				setSnackBarAlert(true);
				setSnackBarAlertMessage('Somthing went wrong');
				console.error('Error', error);;
			}
		}
	};

	const handleResetSubmit = (event) => {
		event.preventDefault();
		let error = false;

		var letters = new RegExp(
			"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$"
		);

		if (password === "" || password === null) {
			error = true;
			setErrorCheckPassword(true);
		} else {
			setErrorCheckPassword(false);
		}

		if (password.length < 8) {
			error = true;
			setErrorCheckPassword(true);
			setPasswordMessage("Passwords length need to be more than 8 Characters");
		} else {
			setErrorCheckPassword(false);
			setPasswordMessage("");
		}

		if (!letters.test(password)) {
			error = true;
			setErrorCheckPassword(true);
			setPasswordMessage(
				"To become strong password, it must contain number, special character and capital letters"
			);
		} else {
			setErrorCheckPassword(false);
			setPasswordMessage("");
		}

		if (confirmPassword !== password) {
			error = true;
			setPasswordConfirmMessage("Passwords don't match");
			setErrorCheckPasswordConfirm(true);
		} else {
			setPasswordConfirmMessage("");
			setErrorCheckPasswordConfirm(false);
		}

		if (!error) {
			const value = {
				token: token,
				newPassword: password
			}
			try {
				PostResetPassword(value).then(({ response, result }) => {
					if (error || !response.ok) {
						let message = 'Something went wrong';

						if (response.status === 404) {
							message = 'If an account with this email exists, a password reset link has been sent.';
						} else if (response.status === 401) {
							message = 'The email you entered is incorrect.';
						} else if (error) {
							message = result?.message || 'Somthing went wrong try refreshing.';
						}

						setSnackBarAlert(true);
						setSnackBarAlertMessage(message);
						return;
					}
					setPasswordResetSuccess(true);
					setModal(true);
				})

			} catch (error) {
				setSnackBarAlert(true);
				setSnackBarAlertMessage('Somthing went wrong');
				console.error('Error', error);;
			}
		}
	};

	const handleClose = () => {
		setEmail('');
		setModal(false);
		setPasswordResetSuccess(false);
		setPassword('');
		setPasswordConfirm('');
		setErrorCheckPassword(false);
		setErrorCheckPasswordConfirm(false);
		setPasswordMessage('');
		setPasswordConfirmMessage('');
	};
	return (
		<div className="main">
			{isLoading ? (
				<LoadingBox>
					<CircularProgress />
				</LoadingBox>
			) : (
				<Grid container alignItems="center" justifyContent="center">
					<StyledCard className="resetBody">
						<CardContent>
							<Grid container alignItems="center" justifyContent="center">
								<Grid item xs={12}>
									<Stack spacing={5} className="formContainer">
										{newPasswordUi ? (<form onSubmit={(e) => handleResetSubmit(e)}>
											<Stack spacing={3}>
												<Stack spacing={3} alignItems="center" textAlign="center">
													<img src={forgotpassword} alt="logo" className="logo" style={{ width: '50%' }} />
													<Typography variant="h2">Reset Your Password</Typography>
													<Typography variant="body1"> Please enter your new password below. </Typography>
												</Stack>
												<Stack spacing={2}>
													<Stack spacing={1}>
														<Typography variant="body1_light">New Password</Typography>
														<StyledTextBox
															error={errorCheckPassword ? true : false}
															fullWidth
															placeholder="Minimum 8 characters"
															value={password}
															onChange={(e) => setPassword(e.target.value)}
															type={showPassword ? "text" : "password"}
															InputProps={{
																endAdornment: (
																	<InputAdornment position="end">
																		<IconButton
																			aria-label="toggle password visibility"
																			onClick={() => setShowPassword(!showPassword)}
																			edge="end"
																		>
																			{showPassword ? (
																				<VisibilityOutlinedIcon />
																			) : (
																				<VisibilityOffOutlinedIcon />
																			)}
																		</IconButton>
																	</InputAdornment>
																),
															}}
														/>
														<Typography variant="body3" color="red">
															{passwordMessage}
														</Typography>
													</Stack>
													<Stack spacing={1}>
														<Typography variant="body1_light">Confirm New Password</Typography>
														<StyledTextBox
															error={errorCheckPasswordConfirm ? true : false}
															fullWidth
															placeholder="Minimum 8 characters"
															value={confirmPassword}
															type={showConfirmPassword ? "text" : "password"}
															InputProps={{
																endAdornment: (
																	<InputAdornment position="end">
																		<IconButton
																			aria-label="toggle password visibility"
																			onClick={() => setShowConfirmPassword(!showConfirmPassword)}
																			edge="end"
																		>
																			{showConfirmPassword ? (
																				<VisibilityOutlinedIcon />
																			) : (
																				<VisibilityOffOutlinedIcon />
																			)}
																		</IconButton>
																	</InputAdornment>
																),
															}}
															onChange={(e) => setPasswordConfirm(e.target.value)}
														/>
														<Typography variant="body3" color="red">
															{passwordConfirmMessage}
														</Typography>
													</Stack>
												</Stack>
												<Stack>
													<ContainedButton
														variant="contained"
														type="submit"
														loading="true"
													>
														Reset Password
													</ContainedButton>
												</Stack>
											</Stack>
										</form>) : (
											<form onSubmit={(e) => handleSubmit(e)}>
												<Stack spacing={3}>
													<Stack spacing={3} alignItems="center" textAlign="center">
														<img src={forgotpassword} alt="logo" className="logo" style={{ width: '50%' }} />
														<Typography variant="h2">Forgot your password?</Typography>
														<Typography variant="body1"> Enter your email address below and,
															we’ll send you a link to reset it. </Typography>
													</Stack>


													<Stack spacing={2}>
														<Stack>
															<Typography variant="body1_light">Email</Typography>
															<StyledTextBox
																required
																placeholder="eg: username@email.com"
																error={checkEmail}
																value={email}
																id="username"
																name="username"
																autoComplete="username"
																onChange={(e) =>
																	setEmail(e.target.value)
																}
																InputProps={{
																	startAdornment: (
																		<InputAdornment position="start">
																			<Person2OutlinedIcon />
																		</InputAdornment>
																	),
																}}
															/>
														</Stack>
													</Stack>
													<Stack>
														<ContainedButton
															variant="contained"
															type="submit"
															loading="true"
														>
															Send Email
														</ContainedButton>
													</Stack>
												</Stack>
											</form>
										)}

										<Stack alignItems="center">
											<Typography variant="body1_light">
												<NavLink
													to="/login"
												>
													<Stack direction="row" alignItems="center" spacing={2} >
														<ArrowBackIcon />
														<span >Back to Login</span>
													</Stack>

												</NavLink>
											</Typography>
										</Stack>
									</Stack>
								</Grid>
							</Grid>
						</CardContent>
					</StyledCard>
				</Grid>
			)}
		<Dialog
			open={modal}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<Box sx={{ p: 6 }}>
				{passwordResetSuccess ? (
					<>
						<Typography variant="h4" textAlign="center" sx={{ fontWeight: 'bold', mb: 2 }}>
							Success!
						</Typography>
						<Typography variant="body1" textAlign="center">
							Your password has been successfully reset. You can now log in with your new password.
						</Typography>
						<br></br>
						<Stack alignItems="center">
							<BlackOutlinedButton 
								variant="outlined" 
								onClick={() => {
									handleClose();
									window.location.href = '/login';
								}}
							>
								Go to Login
							</BlackOutlinedButton>
						</Stack>
					</>
				) : (
					<>
						<Typography variant="body1" textAlign="center">
							If an account exists with that email, a reset link has been sent. Please check your inbox.
						</Typography>
						<br></br>
						<Stack alignItems="center">
							<BlackOutlinedButton variant="outlined" onClick={handleClose}>
								Close
							</BlackOutlinedButton>
						</Stack>
					</>
				)}
			</Box>
		</Dialog>			<AlertSnackbar
				open={snackBarAlert}
				message={snackBarAlertMessage}
				type="error"
				onClose={() => setSnackBarAlert(false)}
			/>
		</div>
	);
}
